import initTableSelectionOnLoad from './initTableSelectionOnLoad';
import loadInitialRowsFromServer from './loadInitialRowsFromServer';
import updateTablesInCache from '../helpers/tableCache/updateTablesInCache';
import { MAX_CACHED_ROWS_TO_SHOW_TABLE_LOAD } from '../data-loading/TableLoadingConstants';
import { returnTopExecutingActionDatapoint } from 'owa-analytics';
/**
 * Performs the first load for a mail table
 * @param tableView - the given mail tableView
 * @param onInitialTableLoadComplete - callback for when the initial table load has completed
 * @param actionSource action that initiated the switch folder action
 * @return a promise that resolves when the load initial table has completed either from server or from cache
 */
export default function loadInitialMailTable(tableView, onInitialTableLoadComplete, actionSource) {
    // load table from cache by setting the currentLoadedIndex
    tableView.currentLoadedIndex = Math.min(MAX_CACHED_ROWS_TO_SHOW_TABLE_LOAD, tableView.rowKeys.length);
    // Init table selection on any cached items we have
    initTableSelectionOnLoad(tableView);
    var isTableViewOfFolderType = tableView.tableQuery.type == 0 /* Folder */;
    // Update tables in cache
    updateTablesInCache(tableView);
    var tableHasCachedItems = tableView.rowKeys.length > 0;
    if (isTableViewOfFolderType &&
        (actionSource === 'FolderNodeClick' ||
            actionSource === 'Keyboard' ||
            actionSource === 'FavoritesPersonaNode')) {
        var datapoint = returnTopExecutingActionDatapoint();
        if (datapoint) {
            datapoint.addCustomProperty('isCached', tableHasCachedItems);
            datapoint.addCustomProperty('scenario', tableView.tableQuery.scenarioType);
        }
    }
    var loadFromServerPromise = loadInitialRowsFromServer(tableView, false /* isTablePrefetched */, onInitialTableLoadComplete);
    // Resolve the initial load promise immediately if we're showing cached items, otherwise resolve when the server returns results
    return tableHasCachedItems ? Promise.resolve() : loadFromServerPromise;
}
//# sourceMappingURL=loadInitialMailTable.js.map